import React, { useState, useEffect, useRef } from 'react';
import { db, auth } from '../../firebase';
import { ref, onValue, update } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
// import AccountantLayout from './AccountantLayout';
import { FaSearch, FaCopy, FaFileExcel, FaPrint, FaEdit, FaTrash, FaEye, FaTimes } from 'react-icons/fa';
import * as XLSX from 'xlsx';

const STATUS_COLORS = {
    Approved: 'text-green-600',
    Accepted: 'text-green-600',
    Rejected: 'text-red-600',
    Pending: 'text-orange-400',
};

// Update Modal
const UpdateModal = ({ isOpen, onClose, data, onStatusUpdate }) => {
    const [status, setStatus] = useState('Pending');
    const [remark, setRemark] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (data) {
            setStatus(data.accountantStatus || 'Pending');
            setRemark(data.accountantRemark || '');
        }
    }, [data]);

    if (!isOpen || !data) return null;

    const handleSave = async () => {
        setSaving(true);
        try {
            await onStatusUpdate(data.id, { 
                accountantStatus: status, 
                accountantRemark: remark,
                accountantUpdateAt: new Date().toISOString()
            });
            onClose();
        } catch (e) {
            console.error(e);
        }
        setSaving(false);
    };

    return (
        <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center p-4 backdrop-blur-sm" onClick={onClose}>
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in duration-200" onClick={e => e.stopPropagation()}>
                <div className="bg-[#2d2360] px-6 py-4 text-white flex justify-between items-center">
                    <h2 className="text-lg font-bold">स्थिती अपडेट करा (Update Status)</h2>
                    <button onClick={onClose} className="text-white hover:text-gray-200"><FaTimes size={20} /></button>
                </div>
                <div className="p-6 space-y-4">
                    <div>
                        <label className="block text-xs font-black text-gray-400 uppercase tracking-widest mb-1">नाव</label>
                        <p className="font-bold text-gray-800">{data.name}</p>
                    </div>
                    <div>
                        <label className="block text-xs font-black text-gray-400 uppercase tracking-widest mb-2">Accountant Status</label>
                        <select 
                            value={status} 
                            onChange={e => setStatus(e.target.value)}
                            className="w-full border-2 border-gray-100 rounded-xl px-4 py-2.5 text-sm font-bold outline-none focus:border-blue-500 transition-all bg-gray-50"
                        >
                            <option value="Pending">Pending</option>
                            <option value="Approved">Approved</option>
                            <option value="Rejected">Rejected</option>
                        </select>
                    </div>
                    <div>
                        <label className="block text-xs font-black text-gray-400 uppercase tracking-widest mb-2">शेरा (Remark)</label>
                        <textarea 
                            rows={3} 
                            value={remark}
                            onChange={e => setRemark(e.target.value)}
                            placeholder="विवरण प्रविष्ट करा..."
                            className="w-full border-2 border-gray-100 rounded-xl px-4 py-2.5 text-sm outline-none focus:border-blue-500 transition-all bg-gray-50 font-medium"
                        />
                    </div>
                    <button 
                        onClick={handleSave} 
                        disabled={saving}
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl text-sm font-black shadow-lg shadow-blue-100 transition-all active:scale-[0.98] disabled:opacity-50"
                    >
                        {saving ? 'प्रक्रिया...' : 'जतन करा (Save)'}
                    </button>
                </div>
            </div>
        </div>
    );
};

const Accountantupdate = () => {
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedApp, setSelectedApp] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();
    const tableRef = useRef(null);

    useEffect(() => {
        const unsubscribeAuth = auth.onAuthStateChanged(user => {
            if (!user) navigate('/login');
        });

        let engOld = [];
        let engNew = [];
        let socOld = [];
        let socNew = [];
        let loadedCount = 0;

        const processAndSet = () => {
            loadedCount++;
            if (loadedCount >= 4) {
                const combined = [...engOld, ...engNew, ...socOld, ...socNew]
                    .sort((a, b) => (b.submittedAtRaw || 0) - (a.submittedAtRaw || 0));
                setApplications(combined);
                setLoading(false);
            }
        };

        // Engineer Old
        const unsubEngOld = onValue(ref(db, 'ekamwatapzp/EngineerRegistrations'), snapshot => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                engOld = Object.keys(data).map(key => {
                    const user = data[key];
                    const inv = (user.payment || {})['Registration status invoice'] || {};
                    return {
                        id: key, node: 'EngineerRegistrations', name: `${user.firstName || ''} ${user.middleName || ''} ${user.surname || ''}`.trim(),
                        phone: user.whatsappNo || user.mobileNo || '-',
                        regDate: user.submittedAt ? new Date(user.submittedAt).toLocaleDateString('en-GB') : '-',
                        apprRejDate: user.approvalDate || user.rejectionDate || '-',
                        reuploadDate: user.reuploadDate || '-',
                        ceoStatus: user.ceoStatus || user.addCEOStatus || 'Pending',
                        engineerStatus: user.engineerStatus || 'Pending',
                        accountantStatus: user.accountantStatus || inv.accountantStatus || (inv.status === 'completed' ? 'Approved' : 'Pending'),
                        assistantStatus: user.assistantStatus || 'Pending',
                        accountantRemark: user.accountantRemark || inv.accountantRemark || '',
                        submittedAtRaw: user.submittedAt ? new Date(user.submittedAt).getTime() : 0
                    };
                });
            } else engOld = [];
            processAndSet();
        });

        // Engineer New
        const unsubEngNew = onValue(ref(db, 'ekamwatapzp/EngineerLotteryRegistrations'), snapshot => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                engNew = Object.keys(data).map(key => {
                    const user = data[key];
                    const inv = (user.payment || {})['Registration status invoice'] || {};
                    return {
                        id: key, node: 'EngineerLotteryRegistrations', name: `${user.firstName || ''} ${user.middleName || ''} ${user.surname || ''}`.trim(),
                        phone: user.whatsappNo || user.mobileNo || '-',
                        regDate: user.submittedAt ? new Date(user.submittedAt).toLocaleDateString('en-GB') : '-',
                        apprRejDate: user.approvalDate || user.rejectionDate || '-',
                        reuploadDate: user.reuploadDate || '-',
                        ceoStatus: user.ceoStatus || user.addCEOStatus || 'Pending',
                        engineerStatus: user.engineerStatus || 'Pending',
                        accountantStatus: user.accountantStatus || inv.accountantStatus || (inv.status === 'completed' ? 'Approved' : 'Pending'),
                        assistantStatus: user.assistantStatus || 'Pending',
                        accountantRemark: user.accountantRemark || inv.accountantRemark || '',
                        submittedAtRaw: user.submittedAt ? new Date(user.submittedAt).getTime() : 0
                    };
                });
            } else engNew = [];
            processAndSet();
        });

        // Society Old
        const unsubSocOld = onValue(ref(db, 'ekamwatapzp/SocietyRegistrations'), snapshot => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                socOld = Object.keys(data).map(key => {
                    const user = data[key];
                    const inv = (user.payment || {})['Registration status invoice'] || {};
                    return {
                        id: key, node: 'SocietyRegistrations', name: user.societyName || '-',
                        phone: user.whatsappNo || user.chairmanWhatsapp || '-',
                        regDate: user.submittedAt ? new Date(user.submittedAt).toLocaleDateString('en-GB') : '-',
                        apprRejDate: user.approvalDate || user.rejectionDate || '-',
                        reuploadDate: user.reuploadDate || '-',
                        ceoStatus: user.ceoStatus || user.addCEOStatus || 'Pending',
                        engineerStatus: user.engineerStatus || 'Pending',
                        accountantStatus: user.accountantStatus || inv.accountantStatus || (inv.status === 'completed' ? 'Approved' : 'Pending'),
                        assistantStatus: user.assistantStatus || 'Pending',
                        accountantRemark: user.accountantRemark || inv.accountantRemark || '',
                        submittedAtRaw: user.submittedAt ? new Date(user.submittedAt).getTime() : 0
                    };
                });
            } else socOld = [];
            processAndSet();
        });

        // Society New
        const unsubSocNew = onValue(ref(db, 'ekamwatapzp/SocietyLotteryRegistrations'), snapshot => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                socNew = Object.keys(data).map(key => {
                    const user = data[key];
                    const inv = (user.payment || {})['Registration status invoice'] || {};
                    return {
                        id: key, node: 'SocietyLotteryRegistrations', name: user.societyName || '-',
                        phone: user.whatsappNo || user.chairmanWhatsapp || '-',
                        regDate: user.submittedAt ? new Date(user.submittedAt).toLocaleDateString('en-GB') : '-',
                        apprRejDate: user.approvalDate || user.rejectionDate || '-',
                        reuploadDate: user.reuploadDate || '-',
                        ceoStatus: user.ceoStatus || user.addCEOStatus || 'Pending',
                        engineerStatus: user.engineerStatus || 'Pending',
                        accountantStatus: user.accountantStatus || inv.accountantStatus || (inv.status === 'completed' ? 'Approved' : 'Pending'),
                        assistantStatus: user.assistantStatus || 'Pending',
                        accountantRemark: user.accountantRemark || inv.accountantRemark || '',
                        submittedAtRaw: user.submittedAt ? new Date(user.submittedAt).getTime() : 0
                    };
                });
            } else socNew = [];
            processAndSet();
        });

        return () => {
            unsubscribeAuth();
            unsubEngOld();
            unsubEngNew();
            unsubSocOld();
            unsubSocNew();
        };
    }, [navigate]);

    const handleStatusUpdate = async (id, updateData) => {
        const app = applications.find(a => a.id === id);
        if (!app) return;
        // Update root and payment node for consistency
        const rootPath = `ekamwatapzp/${app.node}/${id}`;
        const invPath = `ekamwatapzp/${app.node}/${id}/payment/Registration status invoice`;
        
        const updates = {};
        updates[`${rootPath}/accountantStatus`] = updateData.accountantStatus;
        updates[`${rootPath}/accountantRemark`] = updateData.accountantRemark;
        updates[`${invPath}/accountantStatus`] = updateData.accountantStatus;
        updates[`${invPath}/accountantRemark`] = updateData.accountantRemark;

        await update(ref(db), updates);
    };

    const filtered = applications.filter(app => 
        (app.name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (app.phone || '').includes(searchTerm)
    );

    const handleCopy = () => {
        const text = filtered.map((app, i) => `${i+1}\t${app.name}\t${app.phone}\t${app.regDate}\t${app.ceoStatus}`).join('\n');
        navigator.clipboard.writeText(text);
        alert('Copied to clipboard!');
    };

    const handleExcel = () => {
        const ws = XLSX.utils.json_to_sheet(filtered.map((app, i) => ({
            '#': i + 1,
            'Applicant Name': app.name,
            'Phone No.': app.phone,
            'Reg. Date': app.regDate,
            'Appr. / Rej Date': app.apprRejDate,
            'Reupload Date': app.reuploadDate,
            'Add. CEO Status': app.ceoStatus,
            'Ex. Engineer Status': app.engineerStatus,
            'Sr. Accountant Status': app.accountantStatus,
            'Jr./ Sr. Assistant Status': app.assistantStatus
        })));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Limit Expansion');
        XLSX.writeFile(wb, 'Limit_Expansion_Applications.xlsx');
    };

    const handlePrint = () => window.print();

    if (loading) return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
        </div>
    );

    return (
        <>
            <div className="min-h-screen bg-[#f4f7fa] p-4 md:p-8">
                {/* Header Section */}
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 px-2">
                    <h1 className="text-xl md:text-2xl font-medium text-gray-700">लिमिट एक्सपांड ॲप्लिकेशन</h1>
                    <div className="text-sm text-gray-400 mt-2 md:mt-0 font-medium">
                        ठाणे जिल्हा परिषद / <span className="text-gray-600">व्हिव लिमिट एक्सपान्ड फॉर्म</span>
                    </div>
                </div>

                {/* Table Card */}
                <div className="bg-white rounded shadow-sm border border-gray-100 overflow-hidden">
                    {/* Toolbar */}
                    <div className="flex flex-col md:flex-row justify-between items-center p-5 gap-4">
                        <div className="flex bg-[#6c757d] rounded overflow-hidden">
                            <button onClick={handleCopy} className="px-4 py-1.5 text-white hover:bg-gray-600 border-r border-gray-500 text-sm font-medium transition-colors">Copy</button>
                            <button onClick={handleExcel} className="px-4 py-1.5 text-white hover:bg-gray-600 border-r border-gray-500 text-sm font-medium transition-colors">Excel</button>
                            <button onClick={handlePrint} className="px-4 py-1.5 text-white hover:bg-gray-600 text-sm font-medium transition-colors">Print</button>
                        </div>
                        <div className="flex items-center gap-2">
                            <label className="text-sm font-medium text-gray-500">Search:</label>
                            <input 
                                type="text"
                                value={searchTerm}
                                onChange={e => setSearchTerm(e.target.value)}
                                className="border border-gray-200 rounded px-3 py-1 text-sm outline-none focus:border-blue-400 transition-all w-48 md:w-64"
                            />
                        </div>
                    </div>

                    {/* Table */}
                    <div className="overflow-x-auto">
                        <table className="w-full text-left text-sm border-collapse">
                            <thead>
                                <tr className="bg-[#f8f9fa] border-y border-gray-100 text-gray-700 font-bold uppercase tracking-tight text-[11px]">
                                    <th className="px-4 py-4 text-center border-r border-gray-200 w-12"># ↑↓</th>
                                    <th className="px-4 py-4 border-r border-gray-200">Applicant Name ↑↓</th>
                                    <th className="px-4 py-4 border-r border-gray-200 whitespace-nowrap">Phone No. ↑↓</th>
                                    <th className="px-4 py-4 border-r border-gray-200 whitespace-nowrap">Reg. Date ↑↓</th>
                                    <th className="px-4 py-4 border-r border-gray-200 whitespace-nowrap">Appr. / Rej Date ↑↓</th>
                                    <th className="px-4 py-4 border-r border-gray-200 whitespace-nowrap text-center">Reupload Date ↑↓</th>
                                    <th className="px-4 py-4 border-r border-gray-200 text-center">Add. CEO Status ↑↓</th>
                                    <th className="px-4 py-4 border-r border-gray-200 text-center whitespace-nowrap">Ex. Engineer Status ↑↓</th>
                                    <th className="px-4 py-4 border-r border-gray-200 text-center whitespace-nowrap">Sr. Accountant Status ↑↓</th>
                                    <th className="px-4 py-4 border-r border-gray-200 text-center whitespace-nowrap">Jr./ Sr. Assistant Status ↑↓</th>
                                    <th className="px-4 py-4 text-center">Action ↑↓</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-100">
                                {filtered.map((item, index) => (
                                    <tr key={item.id} className="hover:bg-blue-50/20 transition-colors">
                                        <td className="px-4 py-5 text-center font-bold text-gray-600 border-r border-gray-100">{index + 1}</td>
                                        <td className="px-4 py-5 font-medium text-gray-700 border-r border-gray-100 uppercase tracking-tight leading-relaxed">
                                            {item.name}
                                        </td>
                                        <td className="px-4 py-5 text-gray-600 border-r border-gray-100">{item.phone}</td>
                                        <td className="px-4 py-5 text-gray-600 border-r border-gray-100 whitespace-nowrap">{item.regDate}</td>
                                        <td className="px-4 py-5 text-gray-600 border-r border-gray-100 whitespace-nowrap">{item.regDate}</td>
                                        <td className="px-4 py-5 text-gray-600 border-r border-gray-100 text-center leading-tight">
                                            {item.reuploadDate}
                                        </td>
                                        <td className="px-4 py-5 text-center border-r border-gray-100">
                                            <span className={`font-bold ${STATUS_COLORS[item.ceoStatus] || STATUS_COLORS.Pending}`}>{item.ceoStatus}</span>
                                        </td>
                                        <td className="px-4 py-5 text-center border-r border-gray-100 font-bold whitespace-nowrap">
                                            <span className={`${STATUS_COLORS[item.engineerStatus] || STATUS_COLORS.Pending}`}>{item.engineerStatus}</span>
                                        </td>
                                        <td className="px-4 py-5 text-center border-r border-gray-100 font-bold whitespace-nowrap">
                                            <span className={`${STATUS_COLORS[item.accountantStatus] || STATUS_COLORS.Pending}`}>{item.accountantStatus}</span>
                                        </td>
                                        <td className="px-4 py-5 text-center border-r border-gray-100 font-bold whitespace-nowrap">
                                            <span className={`${STATUS_COLORS[item.assistantStatus] || STATUS_COLORS.Pending}`}>{item.assistantStatus}</span>
                                        </td>
                                        <td className="px-4 py-5">
                                            <div className="flex items-center justify-center gap-2">
                                                <button 
                                                    onClick={() => { setSelectedApp(item); setIsModalOpen(true); }}
                                                    className="p-1.5 text-gray-400 hover:text-blue-600 transition-colors"
                                                >
                                                    <FaEdit size={14} title="Update Status" />
                                                </button>
                                                <button className="p-1.5 text-gray-400 hover:text-red-600 transition-colors">
                                                    <FaTrash size={12} title="Delete" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {filtered.length === 0 && (
                            <div className="p-12 text-center text-gray-400 font-medium italic">No applications found.</div>
                        )}
                    </div>
                    {/* Pagination dummy bar */}
                    <div className="p-5 border-t border-gray-50 flex justify-between items-center text-xs text-gray-400 font-bold uppercase tracking-widest">
                        <span>Showing {filtered.length} entries</span>
                        <div className="flex gap-1">
                            <button className="px-3 py-1 border border-gray-200 rounded hover:bg-gray-50">Previous</button>
                            <button className="px-3 py-1 bg-blue-600 text-white rounded">1</button>
                            <button className="px-3 py-1 border border-gray-200 rounded hover:bg-gray-50">Next</button>
                        </div>
                    </div>
                </div>
            </div>

            <UpdateModal 
                isOpen={isModalOpen} 
                onClose={() => setIsModalOpen(false)} 
                data={selectedApp} 
                onStatusUpdate={handleStatusUpdate}
            />
        </>
    );
};

export default Accountantupdate;
